<script setup lang="ts"></script>

<template>
  <div class="mb-4 flex flex-wrap items-end justify-end gap-2 -mx-2 sm:mb-2 sm:flex-nowrap">
    <slot></slot>
  </div>
</template>
